import { combineReducers } from 'redux';

// Scores
import { actions } from '../actions';

import { accountReducer as accounts } from './account';
import { configurationReducer as configuration } from './configuration';
import { metricsReducer as metrics } from './metrics';
import { contributorsReducer as contributors } from './contributors';
import { currentTeamsReducer as currentTeams } from './teams';
import { repositoriesReducer as repositories } from './repositories';
import { servicesReducer as services } from './services';
import { issueTypesReducer as issueTypes } from './issue-types';
import { prsReducer as prs } from './prs';
import { organizationReducer as organization } from './organization';
import { uiStateReducer as uiState } from './ui-state';
import { showLoaderReducer as showLoader } from './show-loader';
import { modalStateReducer as modalState } from './modal-state';
import { sensorAuthorizationsReducer as sensorAuthorizations } from './sensor-authorizations';
import { boardsReducer as boards } from './boards';
import { iterationsReducer as iterations } from './iterations';
import { invitationsReducer as invitations } from './invitations';
import { projectsReducer as projects } from './projects';
import branches from './branches';
import branchesV2 from './branches-v2';
import releases from './releases';
import { jobsReducer as jobs } from './jobs';
import allSettings from './settings';

const createReducer =
  (actionName, initialState) =>
  (state = initialState, action) => {
    switch (action.type) {
      case actions[`${actionName}_SUCCEED`]:
        return action.payload;
      case actions[`${actionName}_FAILURE`]:
        return initialState;
      default:
        return state;
    }
  };

export default affectedByReset(
  combineReducers({
    showLoader,
    jobs,
    accounts,
    configuration,
    metrics,
    contributors,
    currentTeams,
    repositories,
    services,
    organization,
    modalState,
    prs,
    sensorAuthorizations,
    boards,
    iterations,
    invitations,
    branches,
    releases,
    branchesV2,
    commitStats: createReducer('GET_COMMIT_STATS', []),
    projects,
    uiState,
    allSettings,
    issueTypes
  })
);

function affectedByReset(reducer) {
  return (state, action) => {
    if (action.type === '@@HARD_RESET') {
      state = undefined;
    }
    return reducer(state, action);
  };
}
